import { SupportComponent } from './support/support.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ContactComponent } from './contact/contact.component';
import { AuthGuardService } from './service/auth.guard';
import { SearchComponent } from './element/search/search.component';
import { ParamsComponent } from './params/params.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AnnotationsComponent } from './annotations/annotations.component';
import { RoiComponent } from './roi/roi.component';
import { AdminGuardService } from './service/admin.guard';
import { ReportComponent } from './report/report.component';
import { AnimationComponent } from './animation/animation.component';
import { ParametersComponent } from './parameters/parameters.component';
import { MonitoringComponent } from './monitoring/monitoring.component';
import { RedirectPlayerComponent } from './element/redirect-player/redirect-player.component';
import { TchekLastScanComponent } from './element/tchek-last-scan/tchek-last-scan.component';
import { RedirectDeviceLocalIpComponent } from './element/redirect-device-local-ip/redirect-device-local-ip.component';
import { ClassificationComponent } from './element/classification/classification.component';
import { DetectionComponent } from './detection/detection.component';
import { SuperAdminGuardService } from './service/superAdmin.guard';
import { DamageControlComponent } from './damage-control/damage-control.component';
import { VinscannerComponent } from './vinscanner/vinscanner.component';

const routes: Routes = [
  {
    path: 'home',
    redirectTo: '/dashboard',
    pathMatch: 'full',
    canActivate: [AuthGuardService]
  },
  {
    path: 'contact',
    component: ContactComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardService]
  },
  {
    path: 'annotations',
    component: AnnotationsComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardService, SuperAdminGuardService]
  },
  {
    path: 'search',
    component: SearchComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardService]
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    pathMatch: 'prefix',
    canActivate: [AuthGuardService]
  },
  {
    path: 'report/:id',
    component: ReportComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardService]
  },
  {
    path: 'support',
    component: SupportComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardService]
  },
  {
    path: 'fasttrack/:id',
    component: DamageControlComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardService]
  },
  {
    path: 'redirectPlayer/:id',
    component: RedirectPlayerComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardService, SuperAdminGuardService]
  },
  {
    path: 'player/:id/:camName/:picNum',
    component: AnimationComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardService]
  },
  {
    path: 'viewer/:id/:picId',
    component: AnimationComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardService]
  },
  {
    path: 'underbody/:id',
    component: AnimationComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardService]
  },
  {
    path: 'classificationImage',
    component: AnimationComponent,
    pathMatch: 'full',
    canActivate: [SuperAdminGuardService]
  },
  {
    path: 'classification/:id/:camName/:picNum',
    component: ClassificationComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardService]
  },
  {
    path: 'detection',
    component: DetectionComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardService]
  },
  {
    path: 'params',
    component: ParamsComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardService]
  },
  {
    path: 'params/:type',
    component: ParamsComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardService]
  },
  {
    path: 'redirection/:id',
    component: RedirectDeviceLocalIpComponent,
    //pathMatch: 'full',
  },
  {
    path: 'user',
    data: { preload: true },
    loadChildren: 'app/user/user.module#UserModule'
  },
  {
    path: 'vehicle',
    data: { preload: true },
    loadChildren: 'app/vehicle/vehicle.module#VehicleModule'
  },
  {
    path: 'terminal',
    data: { preload: true },
    loadChildren: 'app/terminal/terminal.module#TerminalModule'
  },
  {
    path: 'parameters',
    component: ParametersComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardService, AdminGuardService]
  },
  {
    path: 'lastscan',
    component: TchekLastScanComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardService]
  },
  {
    path: 'vinscanner',
    component: VinscannerComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardService]
  },
  {
    path: 'monitoring',
    component: MonitoringComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardService, SuperAdminGuardService]
  },
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: '/dashboard', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  declarations: [],
  exports: [RouterModule]
})
export class AppRoutingModule { }
export const routingComponents = [HomeComponent, ContactComponent];



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts